






























import Notification from '@/types/Notification.interface'
import Vue, { PropType } from 'vue'
import mixin from '@/mixins/notifications-mixin'
import IListTile from '@/types/components/IListTile.interface'
import IListAction, { IListActionType } from '@/types/components/IListAction.interface'
import IListIcon from '@/types/components/IListIcon.interface'
import Button from '@/types/components/Button.interface'

export default Vue.extend({
    mixins: [mixin],
    props: {
        //  The notifications displayed in the list
        notifications: {
            type: Array as PropType<Notification[]>,
            default: []
        }
    },
    methods: {
        //  Define the notification IList tile
        notificationsTile(): IListTile {
            return {
                leftIcon: (n: Notification): IListIcon => this.notificationIcon(n),
                line1: (n: Notification): string => n.data.title,
                line2: (n: Notification): string => n.data.text,
                link: (n: Notification): Button => this.notificationButton(n),
                actionContent: (n: Notification): IListAction => {
                    return {
                        type: IListActionType.button,
                        button: {
                            icon: 'bi-bookmark-check',
                            tooltip: 'Mark as Read',
                            tooltipLeft: true,
                            color: 'primary',
                            callback: () => this.$emit('dismiss', n)
                        }
                    }
                }
            }
        }
    }
})
